import React from 'react';
import { ArrowRight, Droplet } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      style={{
        position: 'relative',
        minHeight: '95vh',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '80px',
        color: 'white',
        overflow: 'hidden'
      }}
    >
      {/* Mountain Background Image */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom',
        zIndex: 0
      }} />
      
      {/* Dark Blue-Gray Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, rgba(45, 56, 65, 0.85) 0%, rgba(58, 65, 73, 0.8) 50%, rgba(67, 75, 84, 0.85) 100%)',
        zIndex: 1
      }} />

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          {/* Pre-heading */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.75rem',
            background: 'rgba(92, 112, 128, 0.6)',
            backdropFilter: 'blur(10px)',
            padding: '0.75rem 1.5rem',
            borderRadius: '3rem',
            fontSize: '0.875rem',
            fontWeight: 600,
            marginBottom: '2rem',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            fontFamily: "'Open Sans', sans-serif"
          }}>
            <Droplet size={20} style={{ color: '#00BFFF' }} />
            Cutting-Edge Hydration Therapy
          </div>
          
          {/* Main Heading */}
          <h1 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            lineHeight: 1.1,
            fontWeight: 700,
            marginBottom: '1.5rem',
            letterSpacing: '-0.02em',
            fontStyle: 'italic'
          }}>
            Give Your Program a Competitive Edge with Hydrogen Water Therapy
          </h1>
          
          {/* Subheading */}
          <h2 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            lineHeight: 1.3,
            fontWeight: 600,
            marginBottom: '1.5rem',
            color: '#7EC0D6',
            fontStyle: 'italic'
          }}>
            Electrolyzed Reduced Hydrogen Water: The Cellular Foundation Your Clients Need
          </h2>
          
          {/* Description */}
          <p style={{
            fontFamily: "'Open Sans', sans-serif",
            fontSize: 'clamp(1.125rem, 2vw, 1.375rem)',
            lineHeight: 1.6,
            marginBottom: '3rem',
            opacity: 0.9,
            maxWidth: '800px',
            margin: '0 auto 3rem',
            color: '#E0E0E0'
          }}>
            Your therapy and counseling programs are essential. Now add hydrogen water—a science-backed hydration system that works at the cellular level to enhance everything you already do. When cellular health improves, your clients feel better, engage deeper, and recover stronger.
          </p>
          
          {/* CTA Buttons */}
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button 
              onClick={scrollToContact}
              style={{
                background: '#00BFFF',
                color: '#1a1a2e',
                border: 'none',
                borderRadius: '0.75rem',
                padding: '1.25rem 2.5rem',
                fontSize: '1.125rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                boxShadow: '0 15px 35px rgba(0, 191, 255, 0.3)',
                fontFamily: "'Open Sans', sans-serif"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)';
                e.target.style.boxShadow = '0 20px 45px rgba(0, 191, 255, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 15px 35px rgba(0, 191, 255, 0.3)';
              }}
            >
              Discover Hydrogen Water Therapy
              <ArrowRight size={24} />
            </button>
          </div>
          
          {/* Trust Message */}
          <div style={{
            marginTop: '4rem',
            paddingTop: '2rem',
            borderTop: '1px solid rgba(255, 255, 255, 0.15)'
          }}>
            <p style={{ 
              fontFamily: "'Open Sans', sans-serif",
              fontSize: '1.125rem', 
              lineHeight: '1.7',
              maxWidth: '800px',
              margin: '0 auto',
              color: '#E0E0E0'
            }}>
              With 7 years of experience serving clients and health businesses, we're bringing cutting-edge hydrogen water technology to recovery programs. Give your facility the competitive advantage of cellular-level hydration therapy that sets you apart.
            </p>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div style={{
        position: 'absolute',
        bottom: '2rem',
        left: '50%',
        transform: 'translateX(-50%)',
        animation: 'bounce 2s infinite',
        zIndex: 2
      }}>
        <ArrowRight size={32} style={{ transform: 'rotate(90deg)', opacity: 0.7, color: '#00BFFF' }} />
      </div>
      
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(-10px); }
        }
      `}</style>
    </section>
  );
};
